import React, { useRef } from "react";
import { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import { RiCoupon5Line } from "react-icons/ri"
import { FaUsers, FaUserFriends, FaTicketAlt, FaDollarSign, FaArrowRight, FaHome, FaChevronRight } from "react-icons/fa"
import axios from "axios"
import { localserver, ROUTE_BASE_URL } from "../../../api/common"
import { useEvent } from "../EventContext"

const Overview = () => {
  const { slug } = useParams()
  const { setEventId } = useEvent()
  const [isSearchbar, toggleSearchBar] = useState(false)
  const [activeTab, setActiveTab] = useState("confirmed")
  const [rows, setRows] = useState([])
  const [showToast, setShowToast] = useState(true)
  const [selectedTicket, setSelectedTicket] = useState("All Tickets")
  const [selecteddate, setSelectedDate] = useState("All Dates")
  const [isDropdownVisible, setDropdownVisible] = useState(false)
  const [isEnabledLoading, setIsEnabledLoading] = useState(false)
  const [eventData, setEventData] = useState({
    event: {},
    total_ticket_quantity: 0,
    total_attendee_quantity: 0,
    total_order: [{ total_amount: "0.00", currency: "INR" }],
    ticket_list: [],
    addons_list: [],
  })
  const [validation, setValidation] = useState({
    success: false,
    can_publish: "No",
    message: "",
    validation: {}
  })

  const handleTicketChange = (eventKey) => {
    setSelectedTicket(eventKey)
  }

  const handleDateSelect = (date) => {
    setSelectedDate(date)
  }

  const getEventById = async (event_id) => {
    try {
      const response = await axios.post(
        `${localserver}/get_event_details_by_event_id`,
        { event_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )
      if (response.data.success) {
        setEventData({
          event: response.data.event,
          total_ticket_quantity: response.data.total_ticket_quantity,
          total_attendee_quantity: response.data.total_attendee_quantity,
          total_order: response.data.total_order,
          ticket_list: response.data.ticket_list,
          addons_list: response.data.addons_list,
        })
      } else {
        console.error("Error: Failed to fetch user data")
      }
    } catch (error) {
      console.error("Error fetching users data:", error)
    }
  }

  const getValidation = async (event_id) => {
    try {
      const response = await axios.post(
        `${localserver}/publish_validation`,
        { event_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )
      if (response.data.success) {
        setValidation(response.data)
      } else {
        console.error("Error: Failed to fetch validation data")
      }
    } catch (error) {
      console.error("Error fetching validation data:", error)
    }
  }

  useEffect(() => {
    setEventId(slug)
    localStorage.setItem("eventId", slug)
    getEventById(slug)
    getValidation(slug)
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsEnabledLoading(true)
    }, 1000)

    return () => clearTimeout(timer)
  }, [])

  const steps = [
    { name: "Basic information", status: validation.validation?.EventInformation?.status === "Yes" ? "active" : "inactive", link: `${ROUTE_BASE_URL}/event-registration-info` },
    // { name: "Location", status: validation.validation?.Settings?.status === "Yes" ? "active" : "inactive" },
    { name: "Settings", status: validation.validation?.Settings?.status === "Yes" ? "active" : "inactive", link: `${ROUTE_BASE_URL}/settings` },
    { name: "Payment settings", status: validation.validation?.PaymentSettings?.status === "Yes" ? "active" : "inactive", link: `${ROUTE_BASE_URL}/payment-settings` },
    { name: "Tax setup", status: validation.validation?.Settings?.status === "Yes" ? "active" : "inactive", link: `${ROUTE_BASE_URL}/settings` },
    { name: "Tickets", status: validation.validation?.Tickets?.status === "Yes" ? "active" : "inactive", link: `${ROUTE_BASE_URL}/event-tickets` },
    // { name: "Discount codes", status: validation.validation?.Settings?.status === "Yes" ? "active" : "inactive" },
    { name: "Email setup", status: validation.validation?.Emails?.status === "Yes" ? "active" : "inactive", link: `${ROUTE_BASE_URL}/event-emails` },
    { name: "Go live", status: validation.can_publish === "Yes" ? "active" : "inactive", link: "#" }
  ]

  const statCards = [
    {
      title: "Attendees",
      value: eventData.total_attendee_quantity || 0,
      icon: <FaUsers size={24} />,
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      bgLight: "#f0f4ff",
    },
    {
      title: "Guests",
      value: 0,
      icon: <FaUserFriends size={24} />,
      gradient: "linear-gradient(135deg, #36d1dc 0%, #5b86e5 100%)",
      bgLight: "#e8f5ff",
    },
    {
      title: "Tickets",
      value: eventData.total_ticket_quantity || 0,
      icon: <FaTicketAlt size={24} />,
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      bgLight: "#fff0f5",
    },
    {
      title: "Revenue in INR",
      value: `${eventData.total_order[0]?.currency || "INR"} ${eventData.total_order[0]?.total_amount || "0.00"}`,
      icon: <FaDollarSign size={24} />,
      gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      bgLight: "#fff8e8",
    },
  ]

  const getTicketColor = (index) => {
    const colors = ["#667eea", "#36d1dc", "#f093fb", "#fa709a", "#5b86e5"]
    return colors[index % colors.length]
  }

  if (!isEnabledLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <div
          style={{
            width: "48px",
            height: "48px",
            border: "4px solid #e5e7eb",
            borderTop: "4px solid #184778",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        ></div>
        <span style={{ color: "#6b7280", fontSize: "16px" }}>Loading event overview...</span>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    )
  }

  return (
    <>
      <div className={`overlay ${isSearchbar ? "active" : ""}`} onClick={() => toggleSearchBar(false)}></div>
      <section className="event_overview_main">
        <div className="container-fluid">

          {/* Header Section with Breadcrumb Card */}
          <div style={{ marginBottom: "22px" }}>
            <div className="brood_comes_div"> 
              <div className="row align-items-center">
                <div className="col-md-6 brood_comes_heading">
                  <h2>
                    <div className="brood_comes_part">
                      <FaHome   />
                    </div>
                    {eventData.event && eventData.event.event_name}
                  </h2>
                  {/* <nav aria-label="breadcrumb">
                    <ol
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <li>
                        <Link
                          to="/events/admin/"
                          style={{
                            color: "#6b7280",
                            textDecoration: "none",
                            transition: "color 0.2s ease",
                          }}
                          onMouseEnter={(e) => (e.currentTarget.style.color = "#184778")}
                          onMouseLeave={(e) => (e.currentTarget.style.color = "#6b7280")}
                        >
                          AMASI
                        </Link>
                      </li>
                      <li style={{ color: "#d1d5db" }}>
                        <FaChevronRight size={10} />
                      </li>
                      <li style={{ color: "#184778", fontWeight: "500" }}>Overview</li>
                    </ol>
                  </nav> */}
                </div>
                
              </div>
            </div>
          </div>
          {/* Setup Guide Section */}
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              padding: "24px",
              boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
              border: "1px solid #e5e7eb",
              marginBottom: "22px",
            }}
          >
            <div className="setup_events_guide" style={{ textAlign: "center", marginBottom: "22px" }}>
              <h3 >
                Event Setup Progress
              </h3>
              {/* <p
                style={{
                  margin: 0,
                  fontSize: "14px",
                  color: "#6b7280",
                }}
              >
                If you have any questions, please don’t hesitate to get in touch.
              </p> */}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                position: "relative",
              }}
            >
              {steps.map((step, index) => (
                <React.Fragment key={index}>
                  {step.link ? (
                    <Link className="process_points_stepup"
                      to={step.link}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                        zIndex: 2,
                        position: "relative",
                        textDecoration: "none",
                        cursor: "pointer",
                        transition: "transform 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)"
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)"
                      }}
                    >
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          backgroundColor: step.status === "active" ? "#28a745" : "#dc3545",
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "14px",
                          fontWeight: 600,
                          marginBottom: "8px",
                          transition: "all 0.2s ease",
                        }}
                      >
                        {index + 1}
                      </div>
                      <span className="setup_names_span" >
                        {step.name}
                      </span>
                      <div className="pending_points_div">
                        {step.status === "active" ? "Completed" : "Pending"}
                      </div>
                    </Link>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                        zIndex: 2,
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          backgroundColor: step.status === "active" ? "#28a745" : "#dc3545",
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "14px",
                          fontWeight: 600,
                          marginBottom: "8px",
                        }}
                      >
                        {index + 1}
                      </div>
                      <span className="setup_names_span" >
                        {step.name}
                      </span>
                      <div style={{ fontSize: "12px", color: "#9ca3af", marginTop: "4px" }}>
                        {step.status === "active" ? "Completed" : "Pending"}
                      </div>
                    </div>
                  )}
                  {index < steps.length - 1 && (
                    <div
                      style={{
                        position: "absolute",
                        left: `${(index + 1) * (100 / steps.length)}%`,
                        top: "16px",
                        width: `${100 / steps.length}%`,
                        height: "2px",
                        backgroundColor: "#e5e7eb",
                        transform: "translateX(-50%)",
                        zIndex: 1,
                      }}
                    />
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>



          {/* Statistics Cards */}
          <div className="row" style={{ marginBottom: "22px" }}>
            {statCards.map((card, index) => (
              <div key={index} className="col-xl-3 col-lg-6 col-md-6 ">
                <div
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    padding: "24px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    border: "1px solid #e5e7eb",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)"
                    e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.12)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)"
                  }}
                >
                  {/* Gradient Background */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      height: "4px",
                      background: card.gradient,
                    }}
                  ></div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "16px",
                    }}
                  >
                    <div>
                      <h6
                        style={{
                          color: "#6b7280",
                          fontSize: "13px",
                          fontWeight: "500",
                          marginBottom: "8px",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        {card.title}
                      </h6>
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#1f2937",
                        }}
                      >
                        {card.value}
                      </div>
                    </div>
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "12px",
                        background: card.bgLight,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: card.gradient.match(/#[a-fA-F0-9]{6}/)?.[0],
                      }}
                    >
                      {card.icon}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Tables Row */}
          <div className="row">
            {/* Tickets Table */}
            <div className="col-md-6 mb-4">
              <div
                style={{
                  background: "white",
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  border: "1px solid #e5e7eb",
                  overflow: "hidden",
                }}
              >
                {/* Card Header */}
                <div
                  style={{
                    padding: "20px 24px",
                    borderBottom: "1px solid #e5e7eb",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: "linear-gradient(to right, #f9fafb, #ffffff)",
                  }}
                >
                  <div className="second_heading" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <FaTicketAlt size={20} style={{ color: "#184778" }} />
                    <h5>

                      Tickets ({eventData.ticket_list.length})
                    </h5>
                  </div>
                  <Link className="link_button"
                    to={`${ROUTE_BASE_URL}/event-tickets`}
                  >
                    View All <FaArrowRight size={14} />
                  </Link>
                </div>

                {/* Card Body */}
                <div
                  style={{
                    maxHeight: "400px",

                  }}
                  className="scrool_bar"
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "separate",
                      borderSpacing: "0",
                    }}
                  >
                    <thead className="overview_table">
                      <tr style={{ background: "#f9fafb" }}>
                        <th
                          style={{

                          }}
                        >
                          Ticket Name
                        </th>
                        <th
                          style={{

                          }}
                        >
                          Sold/Qty
                        </th>
                        <th
                          style={{

                          }}
                        >
                          Total Sale
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {eventData.ticket_list.map((ticket, index) => (
                        <tr
                          key={ticket.id}
                          style={{
                            borderBottom: "1px solid #f3f4f6",
                            transition: "background 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#f9fafb"
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "white"
                          }}
                        >
                          <td style={{ padding: "16px 24px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                              <div
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "8px",
                                  background: `${getTicketColor(index)}15`,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: getTicketColor(index),
                                }}
                              >
                                <FaTicketAlt size={18} />
                              </div>
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  color: "#1f2937",
                                }}
                              >
                                {ticket.ticket_name}
                              </span>
                            </div>
                          </td>
                          <td style={{ padding: "16px 24px" }}>
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#4b5563",
                              }}
                            >
                              {ticket.sale_count} /{" "}
                              {`${ticket.quantity}` === "0" || ticket.quantity == null ? "∞" : ticket.quantity}
                            </span>
                          </td>
                          <td style={{ padding: "16px 24px" }}>
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#184778",
                              }}
                            >
                              {ticket.sale_count > 0 && ticket.price
                                ? `${eventData.total_order[0]?.currency || "INR"} ${(
                                  ticket.sale_count * Number.parseFloat(ticket.price)
                                ).toFixed(2)}`
                                : "0"}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Add-ons Table */}
            <div className="col-md-6 mb-4">
              <div
                style={{
                  background: "white",
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  border: "1px solid #e5e7eb",
                  overflow: "hidden",
                }}
              >
                {/* Card Header */}
                <div 
                  style={{
                    padding: "20px 24px",
                    borderBottom: "1px solid #e5e7eb",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: "linear-gradient(to right, #f9fafb, #ffffff)",
                  }}
                >
                  <div className="second_heading" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <RiCoupon5Line size={20} style={{ color: "#184778" }} />
                    <h5  >
                      Add-ons ({eventData.addons_list.length})
                    </h5>
                  </div>
                  <Link className="link_button"
                    to={`${ROUTE_BASE_URL}/event-addons`}


                  >
                    View All <FaArrowRight size={14} />
                  </Link>
                </div>

                {/* Card Body */}
                <div
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "separate",
                      borderSpacing: "0",
                    }}
                  >
                    <thead className="overview_table">
                      <tr style={{ background: "#f9fafb" }}>
                        <th >
                          Addon Name
                        </th>
                        <th
                          style={{

                          }}
                        >
                          Qty
                        </th>
                        <th
                          style={{

                          }}
                        >
                          Total Sale
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {eventData.addons_list.map((addon, index) => (
                        <tr
                          key={addon.id}
                          style={{
                            borderBottom: "1px solid #f3f4f6",
                            transition: "background 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#f9fafb"
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "white"
                          }}
                        >
                          <td style={{ padding: "16px 24px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                              <div
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "8px",
                                  background: `${getTicketColor(index)}15`,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: getTicketColor(index),
                                }}
                              >
                                <RiCoupon5Line size={18} />
                              </div>
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  color: "#1f2937",
                                }}
                              >
                                {addon.add_on_name}
                              </span>
                            </div>
                          </td>
                          <td style={{ padding: "16px 24px" }}>
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#4b5563",
                              }}
                            >
                              {`${addon.quantity}` === "0" || addon.quantity === null ? "∞" : addon.quantity}
                            </span>
                          </td>
                          <td style={{ padding: "16px 24px" }}>
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#184778",
                              }}
                            >
                              {addon.price && addon.quantity && Number.parseFloat(addon.price) > 0
                                ? `${eventData.total_order[0]?.currency || "INR"} ${(
                                  addon.sale_count * Number.parseFloat(addon.price)
                                ).toFixed(2)}`
                                : "0"}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Overview